/* @flow */
import FeatureSpecificIndexHandler from './FeatureSpecificIndexHandler';

export default FeatureSpecificIndexHandler;
